import RestService from "../RestService";
import REST_URLS from "../RestUrls.constants";

const base = REST_URLS.EXTERNAL.baseUrl;
const endpoints = REST_URLS.EXTERNAL.endpoints;

export default {
  createAccount(data) {
    let url = base + endpoints.createAccount;
    return RestService.postRequest(url, data);
  },

  login(data) {
    let url = base + endpoints.login;
    return RestService.postRequest(url, data);
  },

  requestPasswordReset(data) {
    let url = base + endpoints.requestPasswordReset;
    return RestService.postRequest(url, data);
  },

  resetPassword(data) {
    let url = base + endpoints.resetPassword;
    return RestService.postRequest(url, data);
  }
};
